export const BUFFER_POLL_INTERVAL_MS = 1000;
export const BUFFER_STALL_POLLS = 3;
export const HEARTBEAT_INTERVAL_MS = 5000;
export const TOKEN_RETRY_DELAY_MS = 3000;
export const MAX_TOKEN_RETRIES = 3;
export const PREVIOUS_TRACK_THRESHOLD_SEC = 3;
export const MEDIA_SEEK_OFFSET_SEC = 10;
